/**
 * @param {string} id
 * @param {number} nr
 * @param {Map<string, Object>} [params]
 * @constructor
 */
function CartItemContract(id, nr, params) {
    /**
     * @type {string}
     */
    this.productId = id;

    /**
     * @type {number}
     */
    this.discount = 0;

    /**
     * @type {number}
     */
    this.nr = nr;

    /**
     * @type {boolean}
     */
    this.invalid = false;

    /**
     * @type {Object}
     */
    this.product = {};

    /**
     * @type {string}
     */
    this.paramPrice = '';

    /**
     * @type {number}
     */
    this.paramPriceModifier = 0;

    /**
     * @type {Map<string, Object>}
     */
    this.params = params || {};
}

export default CartItemContract;
